import { api } from '@/lib/api';
import { queryClient } from '@/providers/query-client';

export const templateLoader = async () => {
    return queryClient.fetchQuery({
        queryKey: ['templates'],
        queryFn: async () => {
            const { data } = await api.template.findAll();
            return data;
        },
    });
};
